import SiteContentEditor from "@/project/jain_elibrary-admin/pages/content/SiteContentEditor";

/** Admin CMS for public /donate page (optional — seed slug `donate`). */
const DonateContent = () => (
  <SiteContentEditor slug="donate" heading="Donate page" />
);

export default DonateContent;
